export const SalesProductTypeOptions = {
	FRONTEND: { value: "FRONTEND", label: "Frontend" },
	BACKEND: { value: "BACKEND", label: "Backend" },
};
export const ServiceProductTypeOptions = {
	LABOR: { value: "LABOR", label: "Labor" },
	PARTS: { value: "PARTS", label: "Parts" },
};
